var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossRedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9625 4.04459C12.6863 3.76834 12.24 3.76834 11.9638 4.04459L8.50001 7.50126L5.03626 4.03751C4.76001 3.76126 4.31376 3.76126 4.03751 4.03751C3.76126 4.31376 3.76126 4.76001 4.03751 5.03626L7.50126 8.50001L4.03751 11.9638C3.76126 12.24 3.76126 12.6863 4.03751 12.9625C4.31376 13.2388 4.76001 13.2388 5.03626 12.9625L8.50001 9.49876L11.9638 12.9625C12.24 13.2388 12.6863 13.2388 12.9625 12.9625C13.2388 12.6863 13.2388 12.24 12.9625 11.9638L9.49876 8.50001L12.9625 5.03626C13.2317 4.76709 13.2317 4.31376 12.9625 4.04459Z",
    fill: "#E44D50"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRedIcon);
export default __webpack_public_path__ + "static/media/CrossRedIcon.78099bdb.svg";
export { ForwardRef as ReactComponent };